import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { SearchBar } from "../searchBar/searchBarLayout";
export const searchModalId = "a11y-search-modal";
export const SearchModalLayout = (props)=>/*#__PURE__*/ _jsxs("dialog", {
        id: searchModalId,
        className: "search-modal",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "search-modal__inner container--mg align--center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "search-modal__content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "form form--search search--modal",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "sr-text",
                                children: "Zoeken"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "search__input-container form__item--icon left",
                                children: /*#__PURE__*/ _jsx(SearchBar, {
                                    id: "site-search-modal",
                                    query: props.searchQuery,
                                    updateSearchQuery: (newQuery)=>props.updateQuery(newQuery),
                                    runSearchQuery: ()=>props.runSearch()
                                })
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: "link link--iconed search-modal__close",
                                onClick: ()=>props.toggleSearchModal(),
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text--xs",
                                        children: "Sluiten"
                                    }),
                                    /*#__PURE__*/ _jsx("svg", {
                                        className: "link__icon",
                                        width: "14px",
                                        height: "14px",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--close-dnb"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "search-modal__overlay",
                id: "search-modal-overlay",
                "aria-hidden": "true",
                onClick: ()=>props.toggleSearchModal()
            })
        ]
    }, "search-modal");
